import actionTypes from "../actions/actionTypes";

const verifications = (
  state = {
    isLoading: false,
    message: "OK",
  },
  action
) => {
  switch (action.type) {
    case actionTypes.VERIFY_EMAIL_AND_PASS_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.VERIFY_EMAIL_AND_PASS_SUCCESS:
      return { ...state, message: "OK", isLoading: false };

    case actionTypes.VERIFY_EMAIL_AND_PASS_FAILURE:
      return { ...state, isLoading: false, message: "Error" };

    default:
      return state;
  }
};

export default verifications;
